export class AuthError extends Error {
  code: string;
  description: string;

  constructor(code: string, description: string, name = 'AuthError') {
    super(description);
    this.name = name;
    this.code = code;
    this.description = description;
    Object.setPrototypeOf(this, new.target.prototype);
  }
}

export class AuthorizationError extends AuthError {
  constructor(code: string, description = 'Authorization failed') {
    super(code, description, 'AuthorizationError');
  }
}

export class NoAuthorizationCodeError extends AuthError {
  constructor(description = 'No authorization code received') {
    super('no_code', description, 'NoAuthorizationCodeError');
  }
}

export class InvalidStateError extends AuthError {
  constructor(description = 'State mismatch - possible CSRF attack') {
    super('invalid_state', description, 'InvalidStateError');
  }
}

export class NoVerifierError extends AuthError {
  constructor(description = 'Code verifier not found') {
    super('no_verifier', description, 'NoVerifierError');
  }
}

export class InitializationError extends AuthError {
  constructor(description = 'Failed to start the authentication process') {
    super('initialization_failed', description, 'InitializationError');
  }
}
